
import React from "react";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { MapPin } from "lucide-react";
import { UseFormReturn } from "react-hook-form";
import { ClienteFormValues } from "../types";
import CepInput from "@/components/address/CepInput";

interface EnderecoSectionProps {
  form: UseFormReturn<ClienteFormValues>;
  handleCepFound: (address: any) => void;
}

const EnderecoSection = ({ form, handleCepFound }: EnderecoSectionProps) => {
  return (
    <div className="bg-purple-50 p-4 rounded-md">
      <h3 className="text-sm font-medium text-purple-800 mb-3 flex items-center">
        <MapPin className="h-4 w-4 mr-2" />
        Endereço
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
        <FormField
          control={form.control}
          name="cep"
          render={({ field }) => (
            <FormItem className="col-span-1">
              <FormLabel>CEP</FormLabel>
              <FormControl>
                <div className="flex space-x-2">
                  <CepInput 
                    value={field.value} 
                    onChange={field.onChange} 
                    onAddressFound={handleCepFound}
                  />
                </div>
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="logradouro"
          render={({ field }) => (
            <FormItem className="md:col-span-2">
              <FormLabel>Logradouro</FormLabel>
              <FormControl>
                <Input {...field} placeholder="Rua, Avenida, etc" className="border-purple-200 focus:border-purple-500" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <FormField
          control={form.control}
          name="bairro"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Bairro</FormLabel>
              <FormControl>
                <Input {...field} placeholder="Bairro" className="border-purple-200 focus:border-purple-500" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="cidade"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Cidade</FormLabel>
              <FormControl>
                <Input {...field} placeholder="Cidade" className="border-purple-200 focus:border-purple-500" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="estado"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Estado</FormLabel>
              <FormControl>
                <Input {...field} placeholder="UF" maxLength={2} className="border-purple-200 focus:border-purple-500" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </div>
  );
};

export default EnderecoSection;
